<script>
  import ConductInspectionItemQuestionText from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionText.vue';
  import ConductInspectionItemQuestionNumber from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionNumber.vue';
  import ConductInspectionItemQuestionCheckbox from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionCheckbox.vue';
  import ConductInspectionItemQuestionList from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionList.vue';
  import ConductInspectionItemQuestionDateTime from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionDateTime.vue';
  import ConductInspectionItemQuestionInstruction from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionInstruction.vue';
  import ConductInspectionItemQuestionAnnotation from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionAnnotation.vue';
  import ConductInspectionItemQuestionPhoto from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionPhoto.vue';
  import ConductInspectionItemQuestionSignature from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionSignature.vue';
  import { ConductInspectionItemQuestionQrCode } from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionQrCode';
  import { ConductInspectionItemQuestionGeolocation } from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionGeolocation';
  import ConductInspectionItemQuestionEntityItem from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionEntityItem.vue';
  import ConductInspectionItemQuestionFile from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/ConductInspectionItemQuestionFile.vue';
  import { ResponsesTypes } from '@/entities/checklist';
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';
  import fileMixin from '@/_legacy/mixins/fileMixin';
  import RichText from '@/ui/components/richText/RichText.vue';
  import { useBuilderMode } from '@/ui/concerns/checklist/useBuilderMode';
  import { getTitle, getHtmlTitle } from '@/ui/helpers/formTranslationsHelper';

  export default {
    name: 'ConductInspectionItemQuestion',
    components: {
      RichText,
      ConductInspectionItemQuestionText,
      ConductInspectionItemQuestionNumber,
      ConductInspectionItemQuestionCheckbox,
      ConductInspectionItemQuestionList,
      ConductInspectionItemQuestionDateTime,
      ConductInspectionItemQuestionInstruction,
      ConductInspectionItemQuestionAnnotation,
      ConductInspectionItemQuestionPhoto,
      ConductInspectionItemQuestionSignature,
      ConductInspectionItemQuestionQrCode,
      ConductInspectionItemQuestionGeolocation,
      ConductInspectionItemQuestionEntityItem,
      ConductInspectionItemQuestionFile,
      ImageAsset,
    },
    mixins: [fileMixin],
    props: {
      entities: {
        type: Object,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
      previewMode: {
        type: [Boolean, String],
        default: false,
      },
    },
    setup() {
      const { isTranslationMode } = useBuilderMode();

      return {
        isTranslationMode,
      };
    },
    computed: {
      component() {
        return (
          {
            [ResponsesTypes.text]:
              'ConductInspectionItemQuestionText',
            [ResponsesTypes.number]:
              'ConductInspectionItemQuestionNumber',
            [ResponsesTypes.checkbox]:
              'ConductInspectionItemQuestionCheckbox',
            [ResponsesTypes.list]:
              'ConductInspectionItemQuestionList',
            [ResponsesTypes.datetime]:
              'ConductInspectionItemQuestionDateTime',
            [ResponsesTypes.instruction]:
              'ConductInspectionItemQuestionInstruction',
            [ResponsesTypes.annotation]:
              'ConductInspectionItemQuestionAnnotation',
            [ResponsesTypes.photo]:
              'ConductInspectionItemQuestionPhoto',
            [ResponsesTypes.signature]:
              'ConductInspectionItemQuestionSignature',
            [ResponsesTypes.qrCode]:
              'ConductInspectionItemQuestionQrCode',
            [ResponsesTypes.geoLocation]:
              'ConductInspectionItemQuestionGeolocation',
            [ResponsesTypes.entityItem]:
              'ConductInspectionItemQuestionEntityItem',
            [ResponsesTypes.file]:
              'ConductInspectionItemQuestionFile',
          }[this.item.response_type] || null
        );
      },
      isRteTitle() {
        return this.item.params?.rte_title;
      },
      title() {
        return getTitle(this.item, this.isTranslationMode);
      },
      htmlTitle() {
        return getHtmlTitle(this.item, this.isTranslationMode);
      },
    },
  };
</script>

<template>
  <div v-if="component && !item.prefillHidden" :id="item.uuid" class="preview__question">
    <h2 class="whitespace-pre-line">
      <ImageAsset
        v-if="item.image_id || item.image"
        class="preview__question-img" :photo="item"
      />
      <span v-if="item.required" class="text-red mr-1">*</span>
      <RichText v-if="isRteTitle" :content="htmlTitle" />
      <span v-else>{{ title }}</span>
      <p v-if="hasFile" class="preview__question-file" @click="saveFile">
        <font-awesome-icon :icon="['far', 'file-alt']" size="lg" />
        {{ $t('common.see-document') }}
      </p>
    </h2>

    <component :is="component" v-bind="$props" v-on="$listeners" />
    <div v-if="item.errors" class="error-text mt-2 text-red">
      {{ item.errors.join(', ') }}
    </div>
  </div>
  <div v-else></div>
</template>
